export default __webpack_public_path__ + "static/media/trending4.bdca3677.png";